module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Medium.024dc32a.woff";